import HeaderFilter from '../../../components/HeaderFilter';
import AccreditedFilter from '../../../components/ui/filters/AccreditedFilter';
import { useAuthStore } from '../../../store';
import PartnerForm from '../PartnerForm';
import PartnerTable from '../PartnerTable';

const VendorPage = () => {
  const api = 'partner/vendors';
  const moduleName = 'Vendor';
  const moduleCode = 'VENDOR';

  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );
  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter
          showCreate={userModuleAccess?.create}
          // Audit view: "only list of accredited should appear". Defaults to All.
          extra={<AccreditedFilter />}
        />
        <PartnerForm api={api} moduleName={moduleName} />
        <PartnerTable
          api={api}
          moduleName={moduleName}
          moduleCode={moduleCode}
        />
      </div>
    </>
  );
};

export default VendorPage;
